import React from 'react'

const VoucherDetails = () => {
  return (
    <div className='w-full'>VoucherDetails</div>
  )
}

export default VoucherDetails